// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneCrystalTranslationFragmentDoc } from './stoneCrystalTranslation.fragment.generated';
export const StoneCrystalFragmentDoc = gql`
    fragment stoneCrystal on StoneCrystal {
  systemCode
  translation(locale: $locale) {
    ...stoneCrystalTranslation
  }
}
    ${StoneCrystalTranslationFragmentDoc}`;